import { useEffect, useRef, useState } from 'react';
import { localDrafts } from '../../../messaging/localDrafts';
import { useLocalDraft } from '../../../messaging/useLocalDraft';

export function queryDraftChanged(record, task) {
  if (!task || !record) return false;
  return (task.version != null && record.value.serverVersion != null && Number(task.version) > Number(record.value.serverVersion))
    || Date.parse(task.updated_at || '') > Number(record.value.serverUpdatedAt || 0);
}
export function serializeEditorDraft(form) {
  return { ...form, images: form.images.map(image => ({ ...image,
    previewUrl: image.previewUrl?.startsWith('blob:') ? undefined : image.previewUrl,
    url: image.url?.startsWith('blob:') ? undefined : image.url,
  })) };
}
export function useQueryLocalDraft({ actor, id, open, loading, task, form, baseline, setForm }) {
  const saved = useLocalDraft(actor, 'query-draft', id);
  const lifecycle = useRef({ actor, id, open: false, cycle: 0 });
  const opening = open && (!lifecycle.current.open || lifecycle.current.actor !== actor || lifecycle.current.id !== id);
  if (opening) lifecycle.current.cycle++;
  lifecycle.current = { actor, id, open, cycle: lifecycle.current.cycle };
  const identity = JSON.stringify([actor, id, lifecycle.current.cycle]);
  const [decision, setDecision] = useState(null), completed = useRef(null), urls = useRef([]);
  const pending = open && !loading && saved.ready && saved.record && decision !== identity && completed.current !== identity;
  useEffect(() => {
    if (!open || opening || loading || !saved.ready || pending || completed.current === identity || !baseline || JSON.stringify(form) === JSON.stringify(baseline)) return;
    setDecision(identity);
    localDrafts.edit(actor, 'query-draft', id, { form: serializeEditorDraft(form), serverVersion: task?.version,
      serverUpdatedAt: Date.parse(task?.updated_at || '') || null }, 1000);
  }, [open, opening, loading, saved.ready, pending, identity, actor, id, form, baseline, task]);
  useEffect(() => () => {
    localDrafts.flush(actor, 'query-draft', id).catch(() => {});
    urls.current.forEach(url => URL.revokeObjectURL(url)); urls.current = [];
  }, [actor, id, open]);
  const clear = () => { completed.current = identity; localDrafts.edit(actor, 'query-draft', id, null, 0); };
  const restore = () => {
    const next = saved.record?.value?.form;
    if (!next) return;
    setDecision(identity);
    setForm({ ...next, images: next.images.map(image => {
      if (!image.file) return image;
      const previewUrl = URL.createObjectURL(image.file); urls.current.push(previewUrl);
      return { ...image, previewUrl };
    }) });
  };
  const discard = () => { setDecision(identity); localDrafts.edit(actor, 'query-draft', id, null, 0); };
  return { pendingDraft: pending ? saved.record : null, draftChanged: queryDraftChanged(saved.record, task), restoreDraft: restore,
    discardDraft: discard, clearLocalDraft: clear };
}
